import React, { useState } from 'react'
import { useSearchParams } from '@remix-run/react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalFooter,
    ModalBody,
    Button,
    Stack,
    Text,
} from '@chakra-ui/react'

import theme from '../../../../Config/theme'

import MobileFilterButton from './Filter/MobileFilterButton'
import FilterAmount from './Filter/FilterAmount'
import FilterEssay from './Filter/FilterEssay'
import FilterState from './Filter/FilterState'

const HeroMobileFilter = ({ onClose, isOpen }) => {
    const [searchParams, setSearchParams] = useSearchParams()

    // Local State
    const [amountMin, setAmountMin] = useState(searchParams.get('amountMin') || '')
    const [amountMax, setAmountMax] = useState(searchParams.get('amountMax') || '')
    const [essay, setEssay] = useState(Boolean((searchParams.get('essay') || 'false').replace(/\s*(false|null|undefined|0)\s*/i, "")))
    // If parameter value state is a string then convert it to array, otherwise set nationwide as default value
    const [state, setState] = useState(searchParams.get('state') ? searchParams.get('state').split(',') : ['nationwide'])

    // Update data when "Apply changes" is clicked
    const handleClick = () => {
        searchParams.set('page', '1')
        amountMin === undefined ? searchParams.set('amountMin', 0) : searchParams.set('amountMin', amountMin)
        amountMax === undefined ? searchParams.set('amountMax', 99999) : searchParams.set('amountMax', amountMax)
        searchParams.set('essay', essay)
        searchParams.set('state', state)
        setSearchParams(searchParams)
        onClose()
    }

    return (
        <>
            <Modal onClose={onClose} isOpen={isOpen} size={'full'}>
                <ModalOverlay />
                <ModalContent>
                    <ModalBody>
                        <Stack direction={'column'}>
                            <Text>Filter by</Text>
                            <MobileFilterButton label={'amount'} content={<FilterAmount state={{ amountMin: amountMin, setAmountMin: setAmountMin, amountMax: amountMax, setAmountMax: setAmountMax }} />} />
                            <MobileFilterButton label={'essay'} content={<FilterEssay state={{ essay: essay, setEssay: setEssay }} />} />
                            <MobileFilterButton label={'state'} content={<FilterState state={{ selectedStates: state, setSelectedStates: setState }} />} />
                        </Stack>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            _active={{}}
                            _focus={{}}
                            _hover={{}}
                            bgColor={theme.default.defaultColor}
                            borderRadius={'full'}
                            onClick={handleClick}
                            width={'full'}
                        >
                            Apply changes
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}

export default HeroMobileFilter